import './styles.css';
function ComponentPassenger({ data, baby, toEdit, editing, type }) {
  const routeType = data?.scale ? 'Escala' : 'Directo';
  return (
    <>
      <div className='tabletPassengersPassenger'>
        <div className='tabletPassengersPassengerL'>

          {type &&
            <p className='tabletPassengersGroupType'>Vuelo de {type}</p>
          }
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>origen</p>
            <p className='tabletPassengersGroupValue'>{data.from}</p>
          </div>
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>destino</p>
            <p className='tabletPassengersGroupValue'>{data.to}</p>
          </div>
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>fecha</p>
            <p className='tabletPassengersGroupValue'>{data.dateDeparture.split('T')[0]}
            </p></div>
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>hora</p>
            <p className='tabletPassengersGroupValue'>{data.dateDeparture.split('T')[1].split('+')[0]}</p>
          </div>
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>tipo de ruta</p>
            <p className='tabletPassengersGroupValue'>{routeType}</p>
          </div>
        </div>
      </div>
      {data?.scale &&
        <div className='tabletPassengersContainerBaby'>
          <p className='tabletPassengersGroupType'>Escalas:</p>
          {
          data?.scale.map((index, key) => {
            return (
              <ComponentPassenger key={key} data={index} baby={true} toEdit={toEdit} editing={editing} />
            )
          })
        }
        </div>
      }
    </>
  )
}


function TabletItinerary({
  list,
  toEdit = () => { },
  editing = false,
  title
}) {
  return (
    <div className='tabletPassengers'>
      <div className='tabletPassengersHead'>
        <p className='tabletPassengersHeadTitle'>{title}</p>
      </div>
      <div className='tabletPassengersBody'>
        {
          list && list.map((index, key) => {
            const type = key === 0 ? 'ida' : 'retorno'
            return (
              <ComponentPassenger
                key={key}
                data={index}
                baby={false}
                toEdit={toEdit}
                editing={editing}

                type={type}
              />
            )
          })
        }
      </div>
    </div>
  )
}

export default TabletItinerary;
